
import React from 'react';

const GridOverlay = () => {
  return (
    <div 
      className="absolute inset-0 opacity-5"
      style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(251,191,36,0.2) 1px, transparent 0)',
        backgroundSize: '60px 60px',
        animation: 'grid-move 120s linear infinite'
      }}
    ></div>
  );
};

export default GridOverlay;
